import { jsx as _jsx } from "react/jsx-runtime";
import { RemovableCard } from '@dixa/lib-shared-habla';
import { useCallback, useEffect, useState } from 'react';
import { conversationsBulkModalActionLabel } from '../../../utils/conversationsBulkModalActionLabel';
import { ConversationsBulkModalTextEditor } from '../../textEditor/conversationsBulkModalTextEditor';
/**
 * Represents the component for the conversations bulk modal internal note
 * action.
 */
export const ConversationsBulkModalInternalNoteAction = ({ conversationIds, onChange, onRemove, }) => {
    const [text, setText] = useState('');
    useEffect(() => onChange({
        type: 'add_internal_note',
        isValid: text.trim().length > 0,
        arg: {
            csids: conversationIds,
            text,
        },
    }), [conversationIds, onChange, text]);
    const handleChange = useCallback((htmlText) => {
        setText(htmlText);
    }, []);
    return (_jsx(RemovableCard, Object.assign({ icon: "sticky-note", title: conversationsBulkModalActionLabel['add_internal_note'], onRemove: () => onRemove('add_internal_note') }, { children: _jsx(ConversationsBulkModalTextEditor, { type: "add_internal_note", onChange: handleChange }) })));
};
